<template>
  <div
    class="d-inline-flex align-items-center"
    @click.stop="copy(value, message)"
  >
    <a-icon
      v-if="!!value"
      type="copy"
      class="font-size-18 mr-2 text-primary cursor-pointer"
    />
    <span v-if="copyWithValue">
      <span v-if="!!value">{{ value }}</span>
      <span v-else>—</span>
    </span>
  </div>
</template>

<script>
import { copyToClipboard } from '@/composables/copy/copyToClipboard.js'

export default {
  props: {
    value: {
      type: [String, Number, null],
      default: '',
    },
    message: {
      type: String,
      default: 'Successfully copied to clipboard',
    },
    copyWithValue: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    copy(value, message) {
      if (!value) {
        return
      }
      copyToClipboard(value, message)
    },
  },
}
</script>

<style lang="scss">
.copy-value-block {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.4s ease;
  border-radius: 4px;
  padding: 4px;
  height: 30px;
  width: 30px;
  min-width: 30px;
  &:hover {
    border: 1px solid var(--kit-color-primary);
    cursor: pointer;
  }
}
</style>
